// Template224: Kuala Lumpur - Día 2 Chinatown & Little India (Page7)
// Intro, Chinatown + SabiasQue + sticker + tip, Kwai Chai Hong + murales, Central Market, Little India, Cómo llegar.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template224 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const block1Title = page?.texts?.[2]?.content;
	const block1Body = page?.texts?.[3]?.content;
	const block1Tip = page?.texts?.[4]?.content;
	const block2Title = page?.texts?.[5]?.content;
	const block2Body = page?.texts?.[6]?.content;
	const block3Title = page?.texts?.[7]?.content;
	const block3Body = page?.texts?.[8]?.content;
	const block4Title = page?.texts?.[9]?.content;
	const block4Body = page?.texts?.[10]?.content;
	const llegarTitle = page?.texts?.[11]?.content;
	const llegarList = page?.texts?.[12]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const img1 = getImageSrc("img1");
	const img1Sticker = getImageSrc("img1-sticker");
	const img2 = getImageSrc("img2");
	const img2Deco = getImageSrc("img2-deco");
	const img3 = getImageSrc("img3");
	const img4 = getImageSrc("img4");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#2E7D5B";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
		marginBottom: 0.5,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px", flex: 1, position: "relative" }}>
				{intro && (
					<Box
						component="p"
						sx={{ ...estiloP, color: "#333", marginBottom: 1.5 }}
					>
						{intro}
					</Box>
				)}

				{/* Chinatown */}
				<Box data-block-id="text-2" sx={{ position: "relative" }}>
					<Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
						{img1 && (
							<Box
								component="img"
								src={img1}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									borderRadius: "12px",
									objectFit: "cover",
								}}
							/>
						)}
						<Box sx={{ width: "60%", position: "relative" }}>
							{block1Title && (
								<Box component="h3" sx={estiloH3}>
									{block1Title}
								</Box>
							)}
							{block1Body && (
								<Box component="p" sx={estiloP}>
									{block1Body}
								</Box>
							)}
							{sabiasQue[0] && (
								<Box
									sx={{
										position: "absolute",
										bottom: isSmallScreen ? -15 : -30,
										right: isSmallScreen ? "46%" : "33%",
									}}
								>
									<SabiasQue
										icono={sabiasQue[0].icono}
										texto={sabiasQue[0].texto}
									/>
								</Box>
							)}
						</Box>
					</Box>
					{img1Sticker && (
						<Box
							component="img"
							src={img1Sticker}
							alt=""
							sx={{
								width: 100,
								position: "absolute",
								bottom: isSmallScreen ? -100 : -80,
								left: 0,
								zIndex: 99,
							}}
						/>
					)}
					{block1Tip && (
						<Box
							sx={{
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 16px 0px",
								padding: "10px 12px",
								fontSize: 11,
								color: "#444",
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: 280,
								marginTop: 1.25,
								position: "absolute",
								bottom: isSmallScreen ? -80 : -40,
								left: isSmallScreen ? 80 : 100,
								zIndex: 999,
							}}
							dangerouslySetInnerHTML={{ __html: block1Tip }}
						/>
					)}
				</Box>

				{/* Kwai Chai Hong */}
				<Box data-block-id="text-3" sx={{ position: "relative", marginTop: isSmallScreen ? 13 : 8 }}>
					<Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
						{img2 && (
							<Box
								component="img"
								src={img2}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									borderRadius: "12px",
									objectFit: "cover",
								}}
							/>
						)}
						{img2Deco && (
							<Box
								component="img"
								src={img2Deco}
								alt=""
								sx={{
									width: 100,
									position: "absolute",
									bottom: isSmallScreen ? -60 : -40,
									right: 0,
									zIndex: 99,
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							{block2Title && (
								<Box component="h3" sx={estiloH3}>
									{block2Title}
								</Box>
							)}
							{block2Body && (
								<Box component="p" sx={estiloP}>
									{block2Body}
								</Box>
							)}
						</Box>
					</Box>
				</Box>

				{/* Central Market */}
				<Box
					data-block-id="text-4"
					sx={{
						display: "flex",
						gap: 2,
						alignItems: "flex-start",
						marginTop: 2,
					}}
				>
					<Box sx={{ width: "60%" }}>
						{block3Title && (
							<Box component="h3" sx={estiloH3}>
								{block3Title}
							</Box>
						)}
						{block3Body && (
							<Box component="p" sx={estiloP}>
								{block3Body}
							</Box>
						)}
					</Box>
					{img3 && (
						<Box
							component="img"
							src={img3}
							alt=""
							sx={{
								width: "40%",
								height: 100,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
				</Box>

				{/* Little India */}
				<Box
					data-block-id="text-5"
					sx={{
						display: "flex",
						gap: 2,
						alignItems: "flex-start",
						marginTop: 2,
					}}
				>
					{img4 && (
						<Box
							component="img"
							src={img4}
							alt=""
							sx={{
								width: "40%",
								height: 100,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					<Box sx={{ width: "60%" }}>
						{block4Title && (
							<Box component="h3" sx={estiloH3}>
								{block4Title}
							</Box>
						)}
						{block4Body && (
							<Box component="p" sx={estiloP}>
								{block4Body}
							</Box>
						)}
					</Box>
				</Box>

				{(llegarTitle || llegarList) && (
					<Box
						data-block-id="text-6"
						sx={{
							backgroundColor: "#dee7e3",
							border: "3px solid #2E7D5B",
							borderRadius: "12px",
							padding: "16px 20px",
							fontSize: 12,
							color: "#333",
							marginTop: 2,
						}}
					>
						{llegarTitle && (
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: 13,
									fontWeight: 700,
									color: "#2e7d5b",
									textTransform: "uppercase",
								}}
							>
								{llegarTitle}
							</Box>
						)}
						{llegarList && (
							<Box
								component="ul"
								sx={{ paddingLeft: 2.5, margin: 0, lineHeight: 1.5 }}
								dangerouslySetInnerHTML={{ __html: llegarList }}
							/>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template224.thumbnail = "/images/template-1.png";
export default Template224;
